import React, { useState } from "react";
import ContactForm from "./ContactForm";

export default function ContactTab({
  contacts,
  onAdd,
  onUpdate,
  onRemove,
}) {
  const [editingIndex, setEditingIndex] =
    useState(null);

  return (
    <div className="erp-section">
      <div
        style={{
          display: "flex",
          justifyContent: "space-between",
          marginBottom: 10,
        }}
      >
        <div className="erp-section-title">
          Contact Persons
        </div>

        <button
          className="btn btn-sm btn-primary"
          onClick={() => setEditingIndex(-1)}
        >
          + Add Contact
        </button>
      </div>

      {editingIndex !== null && (
        <ContactForm
          initialData={
            editingIndex >= 0
              ? contacts[editingIndex]
              : null
          }
          onCancel={() => setEditingIndex(null)}
          onSave={(data) => {
            if (editingIndex >= 0) {
              onUpdate(editingIndex, data);
            } else {
              onAdd(data);
            }
            setEditingIndex(null);
          }}
        />
      )}

      <table className="table table-bordered">
        <thead className="table-light">
          <tr>
            <th>Name</th>
            <th>Mobile</th>
            <th>Email</th>
            <th>Primary</th>
            <th>Status</th>
            <th width="140">Action</th>
          </tr>
        </thead>

        <tbody>
          {contacts.length === 0 && (
            <tr>
              <td
                colSpan={6}
                className="text-center text-muted"
              >
                No contacts added
              </td>
            </tr>
          )}

          {contacts.map((c, i) => (
            <tr key={i}>
              <td>{c.name}</td>
              <td>{c.mobile}</td>
              <td>{c.email}</td>
              <td>{c.is_primary ? "✔" : ""}</td>
              <td>
                {c.is_active ? "Active" : "Inactive"}
              </td>
              <td>
                <button
                  className="btn btn-sm btn-outline-primary me-2"
                  onClick={() =>
                    setEditingIndex(i)
                  }
                >
                  Edit
                </button>

                <button
                  className="btn btn-sm btn-outline-danger"
                  onClick={() => onRemove(i)}
                >
                  Delete
                </button>
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
}
